

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form9StatusInfoType } from '@/types/Information/Form9';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form9ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form9StatusInfoType;

}
